import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Box } from '@chakra-ui/react'
import useStore from '../../../store'
import { Widget, WidgetHeader, WidgetBody } from '../../ui/Widget'
import QuoteResult from './QuoteResult'
import Spinner from '../../common/Spinner'
import BackButton from '../../common/BackButton'
import useTransportationBasePath from '../../../hooks/useTransportationBasePath'
import CarpoolSupportButton from '../CarpoolSupportButton'

export default function CarpoolQuotePage() {
  const { quoteId } = useParams()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const basePath = useTransportationBasePath()
  const { carpoolQuote, getCarpoolQuote } = useStore()
  const setAlertMessage = useStore((state) => state.setAlertMessage)
  const [loading, setLoading] = useState(!carpoolQuote || String(carpoolQuote.id) !== quoteId)

  useEffect(() => {
    setLoading(true)
    getCarpoolQuote(quoteId).finally(() => setLoading(false))
  }, [quoteId])

  useEffect(() => {
    if (!carpoolQuote || String(carpoolQuote.id) !== quoteId) return
    if (carpoolQuote.attributes?.['is-expired']) {
      setAlertMessage(t('This quote has expired.'))
      navigate(`${basePath}/quotes`)
    }
  }, [carpoolQuote, quoteId])

  const isReady = carpoolQuote && String(carpoolQuote.id) === quoteId

  return (
    <>
      <Widget>
        <WidgetHeader
          title={t('Transport Quote')}
          showSpinner={loading}
          actionIcon={<CarpoolSupportButton />}
          overrideHeaderStyle={true}
        >
          <BackButton
            styles="w-fit text-grey-300 hover:text-grey-100"
            label={t('All Quotes')}
            onClick={() => navigate(`${basePath}/quotes`)}
          />
        </WidgetHeader>
        <WidgetBody isVisible>
          {loading ? (
            <Box display="flex" justifyContent="center" alignItems="center" w="full" py={10}>
              <Spinner />
            </Box>
          ) : isReady ? (
            <QuoteResult quote={carpoolQuote} />
          ) : null}
        </WidgetBody>
      </Widget>
    </>
  )
}
